module.exports = __webpack_public_path__ + "img/icon-nav-report.608ff51.svg";